import CompanyCardEmpty from "app/pages/sales-intelligence/pages/company-analysis/components/cards/company-card/CompanyCardEmpty/CompanyCardEmpty";
import { CardErrorBoundary } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/CardErrorBoundary/CardErrorBoundary";

import CompanyCard from "./CompanyCard";

const CompanyCardWithErrorBoundary = () => (
    <CardErrorBoundary
        dataAutomation="company-card"
        fallbackContent={<CompanyCardEmpty />}
    >
        <CompanyCard />
    </CardErrorBoundary>
);

export default CompanyCardWithErrorBoundary;
